import { render, staticRenderFns } from "./storeHistoryListComponent.vue?vue&type=template&id=2c3f923b&"
import script from "./storeHistoryListComponent.vue?vue&type=script&lang=ts&"
export * from "./storeHistoryListComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports